const defaultConfig = {
  language: "English",
  localisation_strings: {
    UPLOAD_PHOTO: "Upload Photo",

    ACTIVE_CASES: "Active cases",
    ADDED_FAMILY_MEMBERS: "Added family Members",
    ADDRESS: "Address",
    FEES_START_FROM: "Fees start from",
    ONLINE_CONSULTATION: "Online consultation",
    CLINIC_WALKIN: "Clinic walk-in",
    FEMALE_DOCTOR: "Female Doctor",
    CONSULT: "Consult",
    YEARS_OF_EXPERIENCE: " years of experience",
    AVAILABLE_TODAY: "Available Today",
    CLEAR_ALL: "Clear all",
    APPLY: "Apply",
    VIDEO: "Video",
    IN_CLINIC: "In-Clinic",
    SEE_ALL: "See All",
    SEE_LESS: "See Less",
    MY_CARE_TEAM: "My Care Team",
    CONNECT_WITH_FAMILY_DOCTORS: "Connect with your family doctors",
    SPECIALIST: "Specialist",
    BOOK_LAB_TESTS: "Book lab tests",
    CONSULT_DOCTORS: "Consult doctors",
    CREATE_FAMILY_PROFILE: "Create family profile",
    SAVE_AND_SHARE_MEDICAL_REPORTS: "Save and share medical reports",
    TRACK_YOUR_HEALTH_STATUS_AND_MORE: "Track your health status and more",
    ENTER_MOBILE_NUMBER: "Enter mobile number",
    MOBILE_NUMBER: "Mobile Number",
    YOU_CAN_CREATE_MULTIPLE_PROFILES_WITH_YOUR_NUMBER:
      "You can create multiple profiles with your number",
    YOU_CAN_ALSO_CONNECT_YOUR_FAMILY_MEMBER_MOBILE_NUMBER_TO_YOUR_ACCOUNT:
      "You can also connect your family member’s mobile number to your account",
    DOCTOR_CONSULTATIONS: "Doctor Consultations",
    CHECK_UPCOMING_CONSULTATION_AND_PREVIOUSLY_CONSULTED_HISTORY:
      "Check upcoming consultation and previously consulted history",
    UPCOMING_CONSULTATION: "Upcoming Consultation",
    CONSULTATION_HISTORY: "Consultation History",
    LAB_TESTS: "Lab tests",
    SEE_UPCOMING_LAB_TESTS_AND_REPORTS_OF_PREVIOUSLY_BOOKED:
      "See upcoming lab tests and reports of previously booked lab tests",
    SCHEDULED_LAB_TESTS: "Scheduled Lab test",
    BOOKED_LAB_TEST_HISTORY: "Booked Lab test history",
    SEND_OTP: "Send OTP",
    SET_YOUR_4_DIGIT_PIN: "Set your 4 digit pin",
    YOU_NEED_TO_WAIT: "You need to wait",
    BEFORE_NEXT_ATTEMPT: "before next attempt!",
    FOR_PATIENTS: "For patients",
    FOOTER_COPYRIGHT:
      "Copyright &copy; 2016, JioHealthHub, All Rights Reserved.",
    CONSULT_WITH_BEST_DOCTOR: "Consult with best doctor",
    DIAGNOSTICS: "Diagnostics",
    SELECT_ADD_ADDRESS: "Select/Add Address",
    BOOK_LAB_TESTS_AND_CHECKUPS: "Book lab tests & checkups",
    PHARMACY: "Pharmacy",
    GET_WELLNESS_AND_HEALTH_PRODUCTS: "Get wellness & health products",
    CONSULTATIONS: "CONSULTATIONS",
    DIAGNOSTIC: "DIAGNOSTIC",
    ORDER_MEDICINE: "ORDER MEDICINE",
    HEALTH_FEED: "HEALTH FEED",
    HOME: "Home",
    SERVICES: "Services",
    ARTICLES: "Articles",
    RECORDS: "Records",
    FAQS: "FAQs",
    ACCOUNTS: "accounts",
    SEARCH_FOR_DOCTORS: "Search for doctors",
    SEARCH_FOR_PHARMACIES: "Search for Pharmacies",
    SEARCH_FOR_BLOOD_BANKS: "Search for Blood Banks",
    BOOK_DIAGNOSTIC_TESTS: "Book Diagnostic Tests",
    BOOK_FULL_BODY_CHECKUPS: "Book Full Body Checkups",
    READ_HEALTH_ARTICLES: "Read health articles",
    PRIVACY_POLICY: "Privacy Policy",
    CONTACT_US: "Contact Us",
    CREATE_YOUR_MPIN_WARNING:
      "Mpin and confirm Mpin should match with length 4",
    ENTER_DOB_DD_MM_YYYY: "Enter DOB(dd-mm--yyyy)",
    WAITING_FOR_OTP: "Waiting for Otp ",
    SECS: "secs",
    
    NAME_WARNING:"Name should be between 3 and 40 characters and start with a letter",
    PLEASE_SELECT_GENDER: "Please select gender",
    PLEASE_ENTER_A_VALID_EMAIL_ADDRESS: "Please enter a valid email address",
    FALLBACK_ERROR_MESSAGE: "Something Went Wrong! Please try again",
    CREATE_ACCOUNT: "Create Account",
    FIRST_NAME: "First Name",
    LAST_NAME: "Last Name",
    SELECT_GENDER: "Select Gender",
    FEMALE: "Female",
    MALE: "Male",
    DATE_OF_BIRTH: "Date of Birth",
    ADD_EMAIL_ID: "Add Email Id",
    ENTER_EMAIL_ID: "Enter Email Id",
    CANCEL: "Cancel",
    SAVE: "Save",
    CALCULATE_BMI: "Calculate BMI",
    USER: "User",
    MPIN_SHOULD_BE_4_DIGITS: "Mpin should be 4 digits",
    MPIN_AND_CONFIRM_MPIN_SHOULD_BE_EQUAL: "Mpin and confirm Mpin should be equal",
    CREATE_YOUR_PIN: "Create your PIN",
    PROFILE_IMAGE_ALT: "Profile image",
    ADD_4_DIGIT_PIN_FOR_ADDED_SECURITY: "Add 4 digit PIN for added security",
    ENTER_YOUR_FOUR_DIGIT_PIN: "Enter your 4 digit PIN",
    ENTER_PIN: "Enter PIN",
    TOGGLE_PIN_VISIBILITY: "Toggle Pin visible",
    CONFIRM_PIN: "Confirm PIN",
    PLEASE_ENTER_CORRECT_DATE_OF_BIRTH: "Please enter correct date of birth!",
    PLEASE_ENTER_CORRECT_EMAIL_ID: "Please enter correct email id",
    PLEASE_ENTER_CORRECT_MOBILE_NO: "Please enter correct mobile no.",
    FORGOT_PIN: "Forgot PIN",
    FORGOT_MPIN_TEXT: "Verify your registration details",
    ENTER_YOUR_DATE_OF_BIRTH: "Enter your Date of Birth",
    ENTER_YOUR_EMAIL_ID: "Enter your Email id",
    EMAIL_ID: "Email ID",
    REGISTERED_EMAIL_ID_IS: "Registered email id is",
    OR: "OR",
    ENTER_YOUR_MOBILE_NO: "Enter your Mobile Number",
    IN: "IN +91 |",
    ENTER_10_DIGIT_MOBILE_NO: "enter 10 digit mobile number",
    ENTER_MOBILE_NO__ENDING_WITH: "Enter mobile no. ending with",
    GET_OTP: "Get OTP",
    PLEASE_ENTER_VALID_OTP_OF_LENGTH_6: "Please enter valid otp of length 6!",
    OTP_ENTERED_IS_WRONG: "otp entered is wrong",
    ENTER_SIX_DIGIT_OTP: "Enter 6 digit OTP",
    FORGOT_MPIN_OTP_INPUT_LABEL: "We’ve sent you a One Time Password (OTP)",
    RESEND_OTP: "Resend OTP",
    NEXT: "Next",
    FORGOT_MPIN_RESEND_OTP_TIMER_TEXT: "You shall receive OTP within",
    SEC: "sec",
    MPIN_UPDATE_DIFFERENT_PINS_WARNING: "Please enter same value for both fields",
    MPIN_UPDATE_INPUT_FIELD_ERROR: "Enter 4 digit pin.",
    SET_NEW_PIN: "Set new PIN",
    HI: "Hi",
    FORGOT_MPIN_SET_PIN_TEXT: "Add 4 digit PIN for added security",
    ADD_4_DIGIT_PIN: "Add 4 digit PIN",
    CONFIRM_MPIN: "Confirm Mpin",
    PROCEED: "Proceed",
    TERMS_AND_CONDITIONS: "Terms & conditions",
    MOBILE_NUMBER_ERROR: "Please enter a valid mobile number",
    OTP_ERROR: "Please enter valid otp",
    PLEASE_ENTER_YOUR_NUMBER: "Please enter your number",
    ENTER_YOUR_MOBILE_NUMBER: "Enter your mobile number",
    ENTER_OTP: "Enter OTP",
    YOU_SHALL_RECEIVE_OTP_WITHIN: "You shall receive OTP within ",
    DONE: "Done",
    CHANGE_NUMBER: "Change Number",
    BY_REGISTERING_YOU_ARE_AGREE_TO_OUR: "By registering you agree to our",
    DO_YOU_WANT_TO_CHANGE_MOBILE_NUMBER: "Do you want to change mobile number?",
    GET_THE_APP: "Get the app",
    APP_STORE: "App Store",
    GOOGLE_PLAY: "Google Play",
    ENTER_4_DIGITS: "Enter 4 digits.",
    PLEASE_ENTER_YOUR_PIN: "Please enter your PIN",
    ENTER_PIN_FOR: "Enter PIN for PERCENTAGE_STRING",
    INCORRECT_MPIN_TEXT_1: "You have incorrectly typed your PIN",
    INCORRECT_MPIN_TEXT_2: "times. Please try again in",
    FORGOT_YOUR_PIN: "Forgot your PIN",
    LOGIN_WITH_DIFFERENT_NUMBER: "Login with a different number",
    USER_PROFILE: "User Profile",
    CANCEL_ICON: "cancel icon",
    PROFILE_ICON: "profile icon",
    SIGN_OUT: "Sign Out",
    ID: "ID",
    FAMILY_PROFILE: "Family Profile",
    ADD_NEW: "Add New",
    SWITCHING_TO: "Switching to",
    S_PROFILE: "'s profile",
    JHHID_ERROR: "Please Enter a valid JHHID",
    CREATE_PROFILE: "Create Profile",
    THIS_IS_AN_IMPORTANT_STEP_TO_ENSURE_YOUR_DATA_IS_SECURE_AND_WILL_NEVER_SHARE_YOUR_NUMBER_WITH_ANY_ORGANISATION:
      "This is an important step to ensure your data is secure & will never share your number with any organisation",
    JIOHEALTHHUB_ID: "JioHealthHub ID",
    ENTER_JIOHH_ID: "Enter JioHH ID",
    USE_MOBILE_NO_INSTEAD: "Use Mobile No. Instead",
    CHANGE_JHH_ID: "Change Jhh Id",
    WE_HAVE_SENT_YOU_ONE_TIME_PASSWORD_VIA_SMS_TO_LINKED_MOBILE_NO_WITH_THIS_JHH_ID:
      "We’ve sent you One Time Password (OTP) Via SMS to linked mobile no with this JHH ID",
    VERIFY: "Verify",
    DO_YOU_WANT_TO_CHANGE_JHHID: "Do you want to change JHH ID?",
    USE_JIOHH_ID_INSTEAD: "Use JioHH Id Instead",
    CHANGE_MOBILE_NO: "Change Mobile No.",
    WE_HAVE_SENT_YOU_ONE_TIME_PASSWORD_VIA_SMS_TO_MOBILE_NO:
      "We’ve sent you One Time Password (OTP) Via SMS to Mobile no",
    PLEASE_SELECT_RELATIONSHIP: "Please select relationship",
    SELECT_RELATIONSHIP: "Select relationship",
    PLEASE_SELECT_YOUR_DATE_OF_BIRTH: "Please select your date of birth",
    PLEASE_ENTER_VALID_DATE_OF_BIRTH: "Please enter valid date of birth",
    YOUR_RELATION_WITH_HIM: "How is this person related to you",
    RELATION_LIST: "relation-list",
    CREATING_PROFILE_GIVES_YOU_FREE_ACCESS_FOR_PERSONALISED_HEALTH_ARTICLES_OFFERS_AND_ALL_OTHER_SERVICES:
      "Creating profile gives you free access for personalised health articles, offers & all other services",
    USE_ANOTHER_MOBILE_NUMBER: "Use another mobile number",
    SELECT_A_FAMILY_MEMBER: "Select a Family Member",
    ADD_A_FAMILY_MEMBER: "Add a family member",
    CHANGE_MOBILE: "Change Mobile",
    NO: "No",
    YES: "Yes",
    BACK_ARROW: "back arrow",
    HELP_AND_SUPPORT_ICON: "help & support icon",
    HELPER_IMAGE: "helper image",
    FAQ_ICON: "FAQ icon",
    HELP_FOR_EVERYTHING: "Help for everything",
    CHOOSE_AS_PER_CONVENIENCE: "Choose as per your convenience",
    FAQs: "FAQs",
    WHATSAPP_CHAT: "WhatsApp Chat",
    EMAIL: "Email",
    FIND_OUR_ANSWER: "Find Out Answer",
    AVAILABILITY: "24 x 7",
    ANYTIME: "Anytime",
    HELP_AND_SUPPORT: "Help & Support",
    JHHLOGO: "jhhlogo",
    JIOHEALTHHUB: "JioHealthHub",
    YOURCOMPLETEHEALTHCOMPANION: "Your complete health companion",
    GETTHEAPP: "Get the app",
    WRONG_MPIN: "Wrong Mpin!",
    NAME_SHOULD_BE_ATLEAST_3_CHARACTERS: "Name should be at least 3 characters",
    NAME_SHOULD_CONTAIN_MAXIMUM_40_CHARACTERS:
      "Name should contain maximum 40 characters",
    NAME_SHOULD_START_WITH_A_LETTER: "Name should start with a letter",
    TYPE_DOB_FORMAT: "Type your date of birth in DD/MM/YYYY",
    VALID_TILL_DATETIME: "Valid till : PERCENTAGE_STRING",
    EXPIRED:"Expired",
    HP_EXPIRING_PARAMS_DESCRIPTION:"The following reports represent your vital profiles. You will not be able to track your health daily if the reports expire. Book a test and renew your reports.",
    NO_DATA_FOUND:"No Data Found",
    HISTORY: "History",
    READ_MORE: "Read More",
    ANALYSIS:"Analysis",
    SET_GOAL: 'Set goal',
    ADD_READING_DATA: "Add Reading data",
    YOUR_LAST: "Your last",
    AVERAGE: "Average",
    ADD_A_CONDITION: "Add a condition",
    CLOSE: "close",
    INVALID_VALUE_STRING_EXPECTED : "invalid value, string expected",
    INVALID_VALUE: "invalid value",
    VALUE_SHOULD_BE_MORE_THAN: "value should be more than",
    VALUE_SHOULD_BE_LESS_THAN: "value should be less than",
    INVALID_DATE: "invalid date",
    INVALID_TIME: "invalid time",
    INVALID_TIME_FUTURE: "Enter time date less than current value",
    ENTER_VALUE: "Enter Value",
    WE_HAVE_ADDED_GOAL: "We've added your goal",
    ENTER_HOURS: "Enter Hours",
    ENTER_MINUTES: "Enter Minutes",
    DATE: "Date",
    TIME: "Time",
    ADD_SYMPTOMS: "Add Symptoms",
    DOWN_ARROW: "Down Arrow",
    // FAMILY_ACCOUNTS:"Family Accounts",
    UP_ARROW: "Up Arrow",
    EDIT: "Edit",
    RECORD_YOUR_SYMPTOMS: "Record your symptoms",
    // KNOW_MORE_ABOUT_THE_TOPIC: "Know more about the topic",
    VIEW_ALL: "View All",
    SOURCE: "Source",
    EXPLORE_MORE: "Explore more",
    CRITICAL_PARAMETERS: "Critical Parameters",
    ALL_PARAMETERS: "All Parameters",
    UPDATE: "Update",
    ERROR_WHILE_LOADING_SYMPTOMS: "Error while loading symptoms. please try again later.",
    CONDITIONS_NO_DATA:"Check the progress of your conditions here, go ahead and add all that apply to you",
    ADD_IMAGE: "add-image",
    ADD_CONDITION: "Add condition",
    SUMMARY: "Summary",
    ALL_SOURCES: "All sources",
    LANG_ICON: "lang icon",
    LOAD_DATA: "load data",
    BLUE_TICK: "blue tick",
    JHH_LOGO: "Jhh logo",
    WHAT_HEALTH_PATRI: "What is Health Patri?",
    WHAT_HEALTH_PATRI_DESCRIPTION: "Health Patri is a comprehensive picture of your overall health. It lets you evaluate your well-being in an intuitive way on the basis of information provided/collated using your reports and devices. You can further book your tests and also consult doctors from within Health Patri.",
    HOW_UPDATE_DATA: "How do I update my data?",
    HOW_UPDATE_DATA_DESCRIPTION: "There are multiple ways in which you can update data in a fieldNEW_LINE1. Manually enter the data using the edit icon against each field.NEW_LINE2.Allow JioHealthHub to access your medical/fitness device and sync data from that device.NEW_LINE3.Upload your medical reports and provide Health Patri the permissions to access them",
    WHAT_CONDITIONS_SECTION: "What is Conditions section?",
    WHAT_CONDITIONS_SECTION_DESCRIPTION: "In conditions section, you can select the conditions/diseases that apply to you. Track and manage the conditions to keep them under check along with booking tests and consulting doctors as you will.",
    WHAT_COLOURED_RING_PROFILE_ICON_FIELDS: "What is the coloured ring around my profile icon and against each field?",
    WHAT_COLOURED_RING_PROFILE_ICON_FIELDS_DESCRIPTION: "Colors signify the state of your well-being with respect to each of the field and also your overall well-being using rings around the profile icon. Green being good, orange being moderate and red being concerning as per the data provided.",
    WHY_NO_HEALTH_PATRI_REFRESH_AFTER_ENTRY: "Why isn't my Health Patri getting refreshed after manual entry?",
    WHY_NO_HEALTH_PATRI_REFRESH_AFTER_ENTRY_DESCRIPTION: "Please check your network connection. After entering the data, it just needs to sync and update which requires no further actions from your side.",
    NO_SAVE_BUTTON_WILL_DATA_BE_SAVED: "I do not see a save/sync button after manual entry, will my data be saved?",
    NO_SAVE_BUTTON_WILL_DATA_BE_SAVED_DESCRIPTION: "Your data once entered through any of the 3 modes, will always be associated with your profile and can be viewed in Health Patri accordingly, subject to network and connectivity.",
    HOW_CAN_DOWNLOAD_HEALTH_PATRI: "How can I download my Health Patri?",
    HOW_CAN_DOWNLOAD_HEALTH_PATRI_DESCRIPTION: "Health Patri is available for Online viewing only",
    HOW_REVOKE_PERMISSION_HEALTH_PATRI: "How do I revoke permissions given to Health Patri?",
    HOW_REVOKE_PERMISSION_HEALTH_PATRI_DESCRIPTION: "You can revoke the permissions by disabling the toggle at  More -> Settings -> Health Data Sharing -> Health Patri",
    HOW_OFTEN_DATA_UPDATE: "How often do I need to update the Data to keep Health Patri updated?",
    HOW_OFTEN_DATA_UPDATE_DESCRIPTION:"Your Parameters get flagged in Health Patri as they near expiry. You can book your Tests accordingly and update/add the information.",
    "CAN_SHARE_HEALTH_PATRI_DOCTOR _FAMILY":"Can I share my Health Patri with my Doctor/Family?",
    "CAN_SHARE_HEALTH_PATRI_DOCTOR _FAMILY_DESCRIPTION": "Health Patri is available for in-app access only. Users who have listed you as 'Family member' can view your Health Patri.",
    YOU_WILL_BE_ABLE_TO_SEE_YOUR_AVERAGE_AFTER_TODAY : "You'll be able to see your average PERCENTAGE_STRING after today",
    CHART:"Chart",
    HEALTH_PATRI:"Health Patri",
    ASSISTANCE_MESSAGE_FOR_HEALTH_PATRI: "I need assistance for Health Patri",
    ASSISTANCE_MESSAGE_FOR_OTHER: "I need assistance",
    ASSISTANCE_MESSAGE_FOR_MPIN: "I need assistance for Mpin",
    PNP_HEADER_LOGIN: "Login",
    VERIFY_PIN: "Verify Pin",
    SEARCH_PATIENT: "Search Patient",
    PROFILE_IMAGE: "Profile Image",
    JHH_ID: "Jio Health Hub Id",
    KNOW_MORE: "Know more",
    LEFT_ARROW: "Left Arrow",
    RIGHT_ARROW: "Right Arrow",
    ARTICLE: "Article",
    NO_RESULT_FOUND:"No Result Found",
    DOING_WELL_ON:"Doing Well On",
    ATTENTION_NEEDED_ON:"Attention needed on",
    KEY_VITALS: "Key Vitals",
    SHOW_LESS:"Show Less",
    SHOW_MORE:"Show More",
    JUST_NOW: "Just now",
    MINUTES_AGO: "minutes ago",
    YESTERDAY: "Yesterday",
    LAST_UPDATE:"Last Update",
    VITALS_DESCRIPTION: "You can see a summary of your key vitals by connecting smart devices or fitness bands or adding parameters manually.",
    CONDITIONS_DESCRIPTION: "You can see a summary of your Conditions here by connecting with your smart devices or updating the parameters and/or reports manually.",
    LIFESTYLE_DESCRIPTION: "You can see a summary of your fitness parameters by connecting smart devices or fitness bands or adding parameters manually.",
    PHYSICAL_HEALTH_DESCRIPTION: "You can see a summary of your organ level health by connecting your smart devices or adding parameters or uploading reports manually.",
    NO_PROFILE_LINKED: "No Profile Linked",
    CONSENT_FOR_HEALTH_DATA_SHARING: "Consent for Health Data Sharing",
    SETTINGS: "Settings",
    APP: "App",
    HEALTH_DATA_SHARE: "Health Data Sharing.",
    ACCEPT: "Accept",
    NO_RECENT_DATA: "No Recent Data",
    TOTAL: "Total",
    INVALID_INTEGER: "Enter a valid integer value",
    HEALTH_PATRI_CAN_NOT_BE_LOADED: "Health Patri cannot be loaded at this time.",
    USER_CONSENT_FOR_HP_MISSING: "User consent for health data sharing is not present",
    EDIT_CONDITIONS: "Edit Conditions",
    ADD_CONDITIONS: "Add Conditions",
    UPLOAD_IMAGE_ERROR: "Unable to upload image due to some technical issue",
    COULD_NOT_UPLOAD_IMAGE_ERROR: "Some error occured while uploading the picture. Please try again",
    UPLOAD_IMAGE: "upload-image-sign", 
    ADD: "Add",
    NO_DATA: "No Data",
    SELECT_LANGUAGE: "Select a Language",
    LOADER: "Loader",
    TURN_OFF_CONCENT_FOR_HEALTHPATRI: "You can withdraw consent for data sharing with HealthPatri by going to",
    SELECT_PARAMETER_TO_VIEW_AND_ADD_DATA: "Select a parameter to view detailed trends and add data",
    MESSAGE_LIMIT_MIN_MAX: "Value should fall in the permissible range of PERCENTAGE_STRING-PERCENTAGE_STRING",
    TODAY:"Today",
    HEALTHPATRI_INTRODUCTION_STEP1: "Indicates the overall well-being in an intuitive way using historical information",
    HEALTHPATRI_INTRODUCTION_STEP2: "Track and manage your existing conditions to keep them under check",
    HEALTHPATRI_INTRODUCTION_STEP3: "Detailed temporal analysis on all the parameters along with possible determinants",
    ENTRIES: "#Entries",
    NUMBER_OF_VALUES: "No. of Values",
    LETS_GO: "Let's Go",
    SKIP: "Skip",
    PLEASE_WAIT_WHILE_WE_ADD_YOUR_READINGS: "Please wait while we upload your readings",
    UPDATED_FEW_HOURS_AGO: "Updated few hours ago",
    UPDATED_FEW_MINUTES_AGO: "Updated few minutes ago",
    UPDATED_JUST_NOW: "Updated just now",
    HOURS_AGO: "Hours ago",
    UPDATED: "Updated",
    SHARED_HEALTHPATRI: "Shared Health Patri",
    ACCESS_VALID_UPTO: "Access valid upto PERCENTAGE_STRING",
    HEALTHPATRI_NOT_SHARED_WITH_DOCTOR: "Health Patri not shared with any doctor.",
    SHARED: "Shared",
    YOUR_LANGUAGE_CHANGED_TO_LANGUAGE : "Your language has been changed to PERCENTAGE_STRING",
    REVOKE_ACCESS_HEALTHPATRI: "Are you sure you want to discontinue access of Health Patri?",
    EXPIRING_PARAMETERS:"Expiring Parameters",
    ENTRY_DELETED_SUCCESSFULLY: "Entry deleted successfully",
    WILL_DELETE_AGGREGATION_ON_CONFIRMING_YES : "Confirming yes will delete all values contributing to the aggregation",
    ARE_YOU_SURE_WANT_TO_DELETE_VALUE : "Are you sure you want to delete this PERCENTAGE_STRING value?",
    MANUAL_ENTRY_ADDED_SUCCESSFULLY : "Manual Entry has been added successfully.",
    ACCESS_RESTRICTED : "You don't have access to this module",
    LOGOUT_MANAGED_HEALTH : "Please logout from Managed health",
    SYSTOLIC_GREATER_THAN_DIASTOLIC : "Systolic value should be greater than Diastolic value",
    NO_ENTRY_FOR_TODAY : "No Entry for Today!",
    NO_ENTRY : "No Entry!",
    NO_ENTRY_FOR_TODAY_MESSAGE : "Looks like you haven’t added any entry for today.", 
    NO_ENTRY_MESSAGE : "Looks like you haven’t added any entry.",
    YOU_CAN_ADD_ENTRY_OR_VIEW_HISTORY : "You can add entry or view your PERCENTAGE_STRING history.",
    YOU_CAN_ADD_ENTRY : "You can add entry for PERCENTAGE_STRING.",
    YOU_CAN_ADD_GOAL_OR_VIEW_HISTORY : "You can add goal or view your PERCENTAGE_STRING history.",
    YOU_CAN_ADD_GOAL : "You can add goal for PERCENTAGE_STRING.",
    ADD_NEW_ENTRY : "Add New Entry",
    VIEW_HISTORY : "View History", 
    ADD_MANUAL_ENTRY : "Add Manual Entry",
    ADD_ENTRY : "Add Entry",
    DATE_AND_TIME: "Date and Time",
    SLEEP_TYPE: "Sleep Type",
    VALUE: "Value",
    SORT_ASCENDING: "Sort in Ascending Order",
    SORT_DESCENDING: "Sort in Descending Order",
    BACK_TO_HEALTH_PATRI: "Back to Health Patri",
    TRY_HARD: "Try Hard",
    ACHIEVED: "Achieved",
    NORMAL_RANGE: "Normal Range"
  },
};

export default defaultConfig;
